
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import * as dto from "../models/dashboard.dto";
import * as model from "../models/dashboard.model";

@Injectable()
export class DashboardService {
    public readonly BaseUrl = '/api/dashboard';

    constructor(public http: HttpClient) { }

    delete(id: string): Observable<string> {
        return this.http.delete<string>(`${this.BaseUrl}/${id}`);
    }

    getAll(): Observable<any> {
        return this.http.get(`${this.BaseUrl}`);
    }

    ////TODO: Handle custom pass-off
    getDashboard(id: string): Observable<model.Dashboard> {
        return this.http.get<dto.Dashboard>(`${this.BaseUrl}/${id}`).pipe(map(d => this.mapDashboard(d)));
    }

    public mapDashboard(d: dto.Dashboard): model.Dashboard {
        let result = model.Dashboard.createFrom(d);
        let service = this;

        result.save = function (): Promise<model.Dashboard> {
            let dto = this.getDto();
            return service.post(dto).toPromise().then(s => this);
        };

        return result;
    }

    /**
     * Saves a Dashboard.  If the moduleGroupId is present, the API will also create the proper navigation 
     * properties for the modulegroup/module
     * @param dashboard Item to save
     * @param moduleGroupId moduleGroupId
     * @param moduleId moduleId
     */
    post(dashboard: dto.Dashboard, moduleGroupId?: string, moduleId?: string): Observable<dto.Dashboard> {
        let url = this.BaseUrl;

        if (moduleGroupId)
            url += `/${moduleGroupId}/${moduleId}`;

        return this.http.post<dto.Dashboard>(url, dashboard);
    }
}